export default "/_next/static/3c6bf751b37187b127d26d5dc96686a5.jpg";